module.exports = __webpack_public_path__ + "static/media/011.183d7f06.jpg";